<div class="notification" [ngClass]="{ hidden: !visible }">
  <div class="icon">
    @switch (type) {
      @case ("error") {
        <img src="assets/icons/error.svg" alt="error" class="error-icon" />
      }
      @case ("success") {
        <img
          src="assets/icons/success.svg"
          alt="success"
          class="success-icon"
        />
      }
      @case ("waiting") {
        <img
          src="assets/icons/waiting.svg"
          alt="waiting"
          class="waiting-icon"
        />
      }
    }
  </div>
  <div class="texts">
    <div class="title" [innerHTML]="title"></div>
    <div class="message" *ngIf="message" [innerHTML]="message"></div>
  </div>
  <button class="close" (click)="visible = false">
    <img src="assets/icons/cross.svg" alt="x" class="close-icon" />
  </button>
</div>
